export const EuroIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeMiterlimit="10"
      {...props}
    >
      <g>
        <path
          d="M10 19.1666C15.0626 19.1666 19.1667 15.0625 19.1667 9.99992C19.1667 4.93731 15.0626 0.833252 10 0.833252C4.9374 0.833252 0.833344 4.93731 0.833344 9.99992C0.833344 15.0625 4.9374 19.1666 10 19.1666Z"
          strokeLinecap="square"
        />
        <path
          d="M13.3333 14.3308C12.5983 14.7567 11.7442 15 10.8333 15C8.07168 15 5.83334 12.7617 5.83334 10C5.83334 7.23833 8.07168 5 10.8333 5C11.7433 5 12.5975 5.24333 13.3325 5.66833"
          strokeLinecap="round"
        />
        <path d="M4.16666 8.33325H9.99999" strokeLinecap="round" />
        <path d="M4.16666 11.6667H9.99999" strokeLinecap="round" />
      </g>
    </svg>
  );
};
